import { uid } from "./postprocess";

const pad = (v, l = 2) => String(v).padStart(l, "0");

export function fmtTime(t, sep = ",") {
  const ms = Math.max(0, Math.round(t * 1000));
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return `${pad(h)}:${pad(m)}:${pad(s)}${sep}${pad(ms % 1000, 3)}`;
}

export function fmtShort(t) {
  const v = Math.max(0, t || 0);
  const m = Math.floor(v / 60);
  const s = (v % 60).toFixed(2);
  return `${m}:${s.padStart(5, "0")}`;
}

export function parseTime(str) {
  const s = String(str).trim().replace(",", ".");
  if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);
  const parts = s.split(":").map(parseFloat);
  if (parts.some(isNaN)) return null;
  return parts.reduce((acc, p) => acc * 60 + p, 0);
}

export const toSRT = (caps) =>
  caps.map((c, i) => `${i + 1}\n${fmtTime(c.start)} --> ${fmtTime(c.end)}\n${c.text}\n`).join("\n");

export const toVTT = (caps) =>
  "WEBVTT\n\n" + caps.map((c) => `${fmtTime(c.start, ".")} --> ${fmtTime(c.end, ".")}\n${c.text}\n`).join("\n");

export function parseSubtitles(text) {
  const blocks = text.replace(/\r/g, "").replace(/^\uFEFF/, "").split(/\n\s*\n/);
  const caps = [];
  for (const b of blocks) {
    const lines = b.split("\n").filter((l) => l.trim() !== "");
    const ti = lines.findIndex((l) => l.includes("-->"));
    if (ti < 0) continue;
    const [a, z] = lines[ti].split("-->").map((x) => parseTime(x.trim().split(" ")[0]));
    const body = lines.slice(ti + 1).join(" ").replace(/<[^>]+>/g, "").trim();
    if (a == null || z == null || !body) continue;
    caps.push({ id: uid(), start: a, end: z, text: body, flag: null });
  }
  return caps.sort((x, y) => x.start - y.start);
}

export function download(content, name, type) {
  const blob = content instanceof Blob ? content : new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
